import { Link } from 'react-router-dom';

const LinkButton = ({
  to,
  onClick,
  extraCss = {},
  className = '',
  style = {},
  children,
}) => (
  <Link
    to={to}
    type="button"
    onClick={onClick}
    className={`appearance-none text-green-medium outline-none hover:text-green-dark focus:text-green-dark ${className}`}
    css={{
      fontSize: '1.3rem',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      textAlign: 'left',
      transition: 'color 0.5s ease',
      textDecoration: 'none',
      ...extraCss,
      ...style,
    }}
  >
    {children}
  </Link>
);

export default LinkButton;
